import { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { twMerge } from 'tailwind-merge';

import LogoImage from '../../../public/images/global/Black_FS_Logo.png';
import WhiteLogoImage from '../../../public/images/global/White_FS_Logo.png';

interface PropTypes {
  rootClasses?: string;
  anchorClasses?: string;
  color?: 'white' | 'black';
  closeSearchDropdown?: any;
}

const Logo: FC<PropTypes> = ({
  rootClasses = '',
  anchorClasses = '',
  color = 'black',
  closeSearchDropdown,
}) => {
  return (
    <div
      aria-label='logo'
      className={twMerge(`w-32 select-none`, rootClasses)}
      title='Foodstories'>
      <Link
        href='/'
        passHref
        className={anchorClasses}
        prefetch={false}
        onClick={closeSearchDropdown}>
        <Image
          priority
          src={color === 'white' ? WhiteLogoImage : LogoImage}
          alt='Foodstories'
          className='w-full object-cover'
        />
      </Link>
    </div>
  );
};

export default Logo;
